// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import ContentSliderB from 'components/PageSections/ContentSliderB'
import ContactBall from 'components/Contact/ContactBall'
import Link from 'components/Link/Link'
import Editable from 'components/Editable/Editable'
import LogoVideo from 'components/svg/logo/logo-video-mask.svg'

class Home extends React.Component {
	constructor() {
		super()
	}

	render() {
		const { page } = this.props
		let contentData = ''

		if ( ! page.featured_slider || ! page.featured_slider.slides ) {
			return <div className="page-home-slider"></div>
		}

		contentData = JSON.stringify( page.featured_slider_for_editor )

		return (
			<div className="page-home">
				<div className="-intro">
					<div className="-inner">
						<div className="-text">
							<h1>Hi, I’m Merryn</h1>

							<p>I’m a graphic/digital designer creating useful, intuitive, brands and products for ambitious businesses.</p>
						</div>

						<div className="-button">
							<Link to="/about" className="button -plain-reverse">Learn more</Link>
						</div>
					</div>
				</div>

				<div className="-m-video">
					<div className="-inner">
						<div className="-content">
							<div className="-svg-mask">
								<LogoVideo />
							</div>

							{/*<div className="-svg-shadow">
								<LogoVideo />
							</div>*/}

							<div className="-video">
								{/*<div className="-mask"></div>*/}

								<svg className="-mask">
									<clipPath id="m-video-clip-path" clipPathUnits="objectBoundingBox"><path d="M0.837,1 C0.833,1,0.83,1,0.826,1 C0.746,0.997,0.695,0.939,0.666,0.816 C0.655,0.769,0.589,0.462,0.568,0.346 L0.567,0.343 C0.542,0.208,0.533,0.169,0.495,0.171 C0.463,0.172,0.447,0.213,0.447,0.215 C0.447,0.215,0.447,0.216,0.447,0.216 L0.437,0.212 C0.437,0.209,0.444,0.146,0.455,0.102 C0.462,0.078,0.489,0,0.581,0 C0.673,0,0.711,0.109,0.721,0.142 C0.731,0.178,0.763,0.329,0.791,0.463 L0.792,0.467 C0.81,0.555,0.828,0.638,0.835,0.67 C0.837,0.677,0.839,0.684,0.84,0.693 L0.84,0.693 C0.855,0.758,0.879,0.866,0.927,0.866 C0.977,0.866,0.989,0.807,0.989,0.804 L1,0.805 C1,0.808,1,0.874,0.966,0.926 C0.919,0.991,0.876,1,0.837,1 L0.837,1 M0.157,0.997 C0.137,0.997,0.115,0.991,0.092,0.979 C0.029,0.944,-0.01,0.824,0.002,0.704 C0.013,0.597,0.067,0.36,0.076,0.321 L0.076,0.321 C0.077,0.317,0.077,0.315,0.077,0.315 L0.087,0.316 C0.087,0.316,0.088,0.317,0.088,0.32 C0.091,0.337,0.102,0.403,0.121,0.525 C0.122,0.533,0.125,0.548,0.128,0.563 L0.128,0.563 C0.132,0.581,0.136,0.601,0.137,0.612 C0.138,0.618,0.139,0.624,0.14,0.63 C0.16,0.747,0.178,0.857,0.237,0.862 C0.28,0.866,0.301,0.8,0.302,0.798 C0.302,0.798,0.302,0.798,0.302,0.798 L0.312,0.8 C0.312,0.803,0.312,0.86,0.276,0.922 C0.258,0.953,0.215,0.997,0.157,0.997 L0.157,0.997 M0.482,1 C0.486,1,0.49,1,0.493,1 L0.493,1 C0.533,1,0.576,0.991,0.623,0.926 C0.661,0.874,0.656,0.808,0.656,0.805 L0.646,0.804 C0.645,0.807,0.634,0.866,0.583,0.866 C0.535,0.866,0.511,0.758,0.497,0.693 L0.497,0.693 C0.495,0.684,0.493,0.677,0.492,0.67 C0.484,0.638,0.467,0.555,0.449,0.467 L0.448,0.463 C0.42,0.329,0.388,0.178,0.378,0.142 C0.368,0.109,0.33,0,0.238,0 C0.146,0,0.119,0.078,0.113,0.102 C0.101,0.146,0.09,0.215,0.09,0.215 L0.101,0.216 C0.102,0.215,0.12,0.172,0.152,0.171 C0.191,0.169,0.2,0.208,0.224,0.343 L0.225,0.346 C0.246,0.462,0.312,0.769,0.323,0.816 C0.352,0.939,0.403,0.997,0.482,1"></path></clipPath>
								</svg>

								<div className="-inner" dangerouslySetInnerHTML={ { __html: `
									<video src="${siteData.videos_url}m-1200.mp4" preload="auto" autoPlay="autoplay" loop muted playsinline></video>
								` } } />
							</div>
						</div>
					</div>
				</div>

				<div className="page-home-slider">
					<Editable
						id="set_featured_slider"
						element="div"
						contentData={ contentData }
					>
						<ContentSliderB slides={ page.featured_slider.slides } />
					</Editable>
				</div>

				<div className="page-home-more">
					<Link to="/ux-ui" className="button -plain-reverse">View all work</Link>
				</div>

				<div className="page-home-contact-ball">
					<div className="-inner">
						<ContactBall />
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Home )



// WEBPACK FOOTER //
// ./views/pages/Home.jsx